const dashboardFieldNames = {
  projectNumber: "projectNumber",
  projectName: "projectName",
  secureProject: "secureProject",
  projectNameNormalized: "projectNameNormalized",
  projectTypeLabel: "projectTypeLabel",

  dateAssigned: "dateAssigned",

  approver: "approver",
  approverName: "approverName",
  daysAvailable: "daysAvailable",
};

const pendingDashboardFieldNames = {
  ...dashboardFieldNames,
  dateAssigned: "dateAssigned",
};

const recentlyApprovedFieldNames = {
  ...dashboardFieldNames,
  dateApproved: "dateApproved",
};

const intakeFieldNames = {
  financeApprovalGroup: "financeApprovalGroup",
  financeApprovalGroupLabel: "financeApprovalGroupLabel",

  productLine0: "productLine0",
  productLineLabel0: "productLineLabel0",

  productLine1: "productLine1",
  productLineLabel1: "productLineLabel1",

  productLine2: "productLine2",
  productLineLabel2: "productLineLabel2",

  projectType: "projectType",

  productCategory: "productCategory",
  productCategoryLabel: "productCategoryLabel",

  intangibleAccountingStandard: "intangibleAccountingStandard",
  platformProject: "platformProject",

  department: "department",
  departmentLabel: "departmentLabel",
};

const pendingIntakeApprovalsFieldNames = {
  ...pendingDashboardFieldNames,
  ...intakeFieldNames,
};

const recentlyApprovedIntakeFieldNames = {
  ...recentlyApprovedFieldNames,
  ...intakeFieldNames,
  approverUserName: "approverUserName",
};

const routingMilestoneApprovalFieldNames = {
  ...pendingDashboardFieldNames,
  scheduleName: "scheduleName",
  parentMilestone: "parentMilestone",
  milestone: "milestone",
  functionalArea: "functionalArea",
  functionalAreaLabel: "functionalAreaLabel",
  projectRoleName: "projectRoleName",
};

const pendingMilestoneApprovalsFieldNames = {
  ...pendingDashboardFieldNames,
  scheduleName: "scheduleName",
  parentMilestone: "parentMilestone",
  milestone: "milestone",
  functionalArea: "functionalArea",
  functionalAreaLabel: "functionalAreaLabel",
  projectRoleName: "projectRoleName",
};

const recentlyApprovedMilestoneFieldNames = {
  ...dashboardFieldNames,
  dateMilestoneApproved: "dateMilestoneApproved",
  scheduleName: "scheduleName",
  parentMilestoneName: "parentMilestoneName",
  milestoneName: "milestoneName",
  functionalArea: "functionalArea",
  functionalAreaLabel: "functionalAreaLabel",
  projectRoleName: "projectRoleName",
};

export {
  dashboardFieldNames,
  intakeFieldNames,
  pendingDashboardFieldNames,
  pendingIntakeApprovalsFieldNames,
  pendingMilestoneApprovalsFieldNames,
  recentlyApprovedFieldNames,
  recentlyApprovedIntakeFieldNames,
  recentlyApprovedMilestoneFieldNames,
  routingMilestoneApprovalFieldNames,
};
